import React from 'react';
import { metrics, subprojects } from '../data/projects';
import { MetricItem, SubprojectItem } from '../types';

export default function Portfolio() {
  return (
    <section id="portfolio">
      <div className="wrap">
        <div className="eyebrow">Enterprise Automation Platforms</div>
        <h2 className="sectitle">Measured Engineering Hours Reclaimed</h2>
        <p className="secintro">
          Production automation pipelines and cloud microservices shipped for UK retail infrastructure — each replacing fragile manual workflows with deterministic, audited software engines.
        </p>

        <div className="metric-grid">
          {metrics.map((m: MetricItem) => (
            <div className="metric-card" key={m.title}>
              <div className="metric-card-top">
                <div className="metric-num">
                  {m.num}
                  <span className="unit">{m.unit}</span>
                </div>
                <div className="metric-tag">{m.tag}</div>
              </div>
              <h3 className="metric-title">{m.title}</h3>
              <p className="metric-desc">{m.desc}</p>
              
              <div className="metric-card-footer">
                <div className="metric-impact-badge">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                    <polyline points="17 6 23 6 23 12"></polyline>
                  </svg>
                  <span>{m.impact}</span>
                </div>
                <div className="card-stack-chips">
                  {m.stack.map((tech) => (
                    <span className="micro-chip" key={tech}>{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="subproject-section-header">
          <h3 className="subproject-section-title">Cloud Microservices &amp; AIOps Workbenches</h3>
        </div>

        <div className="subproject-grid">
          {subprojects.map((sp: SubprojectItem) => (
            <div className="subproject" key={sp.title}>
              <div className="subproject-top">
                <div className="stat">{sp.stat}</div>
                <div className="subproject-category">{sp.tag}</div>
              </div>
              <h4 className="subproject-title">{sp.title}</h4>
              <p className="subproject-desc">{sp.desc}</p>
              <div className="card-stack-chips">
                {sp.stack.map((tech) => (
                  <span className="micro-chip" key={tech}>{tech}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
